const toggleMenu = () => {
  return {
    type: 'TOGGLE_MENU',
  };
};

export { toggleMenu };
